module.exports = __webpack_public_path__ + "img/xwzxbg.fedb66d7.png";